/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export interface DChartSeriesPointComputedOptions {
	x?: number;
	y?: number;
}

export interface DChartSeriesPointComputed {
	x: number;
	y: number;
}
